module.exports = __webpack_public_path__ + "static/tapfiliate-a421b31a341892b4b927d8ca9e9f3c59.png";